<template>
  <div class="popup">
    <div class="popup__head">
      <span class='questions__bill'>1</span> Select question
    </div>
    <div class="popup__body">
      <div class="popup__mass d-block">
        <div class="popup__question">
          <div class="popup__topic">question</div>
          <vue-select v-model="form.use_question_id" :options="questionsOptions"/>
        </div>
        <div class="popup__answers">
          <div class="popup__topic">Possible answers</div>
          <div class="text-muted mb-2" v-if="selectedQuestion.answers_dictionary && selectedQuestion.answers_dictionary.type">
            <small>
              Dictionary: <b>{{ selectedQuestion.answers_dictionary.type }}</b>
            </small>
            <vue-select v-model="selectedQuestion.answers_dictionary.countries_id"
                        :options="getCountriesOptions()"
                        :settings="{ multiple: true }"/>
          </div>
          <div class="questions__checkbox" v-for="answer of answersOptions">
            <label class="checkbox">
              <input type="checkbox" v-model="form.use_answers_id" :value="answer.id"/>
              <span class="checkbox__part">
                <span class="checkbox__text">{{ answer.text }}</span>
              </span>
            </label>
          </div>
        </div>
      </div>
      <div class="popup__cellar">
        <button class="popup__submit" @click="onSubmit">Submit</button>
        <button class="popup__cancel" @click="closeModal(true)">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: "ModalSelectSurveyQuestion",
    data() {
      return {
        form: {
          parent_id: null,
          use_question_id: null,
          use_answers_id: []
        }
      }
    },
    computed: {
      ...mapGetters([
        'getQuestions',
        'getModalData',
        'getCountriesOptions',
      ]),
      selectedQuestion() {
        for (let question of this.getQuestions)
          if (question.id == this.form.use_question_id)
            return question
        return {}
      },
      questionsOptions() {
        let questions = []
        for (let question of this.getQuestions)
          if (!this.getModalData.added_base_questions.includes(question.id))
            questions.push({id: question.id, text: question.number ? question.number + ' - ' + question.text.en : question.text.en})
        return questions
      },
      answersOptions() {
        let answers = []
        for (let question of this.getQuestions)
          if (this.form.use_question_id == question.id)
            for (let answer of question.answers)
              answers.push({id: answer.id, text: answer.text.en})
        return answers
      }
    },
    mounted() {
      this.queryQuestions()
    },
    methods: {
      ...mapActions([
        'queryQuestions',
        'storeUseQuestion',
        'closeModal',
        'setToast',
      ]),
      onSubmit() {
        if (this.getModalData.parent_id)
          this.form.parent_id = this.getModalData.parent_id
        if (this.getModalData.poll_id)
          this.form.poll_id = this.getModalData.poll_id
        if (this.getModalData.is_draft)
          this.form.is_draft = this.getModalData.is_draft
        this.form.sort = this.getModalData.sort
        this.storeUseQuestion(this.form)
      }
    }
  }
</script>

<style>

</style>